import { type AxiosInstance } from 'axios'

type Metric = {
  name: string
  topic: number
  templates?: number[]
  pre_configuration?: null | {
    name: string
    ui_name: string
  }
  data_aggregation_type?: string
  status?: 'draft' | 'published'
  information_guidance?: null | string
  tutorial_video?: null | string
  metric_table?: null | {
    data: (null | number | string)[][]
    mergedCells:
      | []
      | Array<{
        col: number
        row: number
        colspan: number
        rowspan: number
        removed: boolean
      }>
  }
  is_approver_required?: boolean
  everyone_to_respond?: boolean
  data_collection_frequency?:
    | null
    | 'monthly'
    | 'quarterly'
    | 'semi-annually'
    | 'annually'
}

type Section = {
  title: string
  theme: string
  order: number
  description: string
}

type UpdatedSection = {
  title?: string
  theme?: string
  order?: number
  description?: string
}

export default (axios: AxiosInstance) => ({
  updateMetric(metricId: string, updateData: Metric) {
    return axios.put(
      `/v1/backstage/questions/metrics/${metricId}/`,
      updateData,
    )
  },
  createMetric(createData: Metric) {
    return axios.post(
      '/v1/backstage/questions-create-metrics/?subdomains=all',
      createData,
    )
  },
  createSections(createData: Array<Section>) {
    return axios.post(
      '/v1/backstage/questions-create-sections/?subdomains=all',
      createData,
    )
  },
  updateSection(sectionId: string, updateData: UpdatedSection) {
    return axios.put(
      `/v1/backstage/questions/sections/${sectionId}/`,
      updateData,
    )
  },
})
